const deleteFrequency = {
  toastr: 'Periodicidade deletada',
  toastr1: 'deletado com sucesso'
};

export default deleteFrequency;
